import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import "./App.css";

/* =====================
   Theme Constants
===================== */
const THEME = {
  LIGHT: "light",
  DARK: "dark",
};

/* =====================
   Utils
===================== */
const getInitialTheme = () => {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme) return savedTheme === THEME.DARK;

  // Fallback to system preference
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};

/* =====================
   Loader Component
===================== */
const Loader = ({ theme }) => (
  <div
    className={`loading-screen ${theme}`}
    role="status"
    aria-busy="true"
    aria-live="polite"
  >
    <div className="loader">
      <div className="loader-orb" />
      <div className="loader-text">Loading...</div>
    </div>
  </div>
);

/* =====================
   App Component
===================== */
const App = () => {
  const [isDark, setIsDark] = useState(getInitialTheme);
  const [isLoading, setIsLoading] = useState(true);

  /* Apply theme immediately */
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle(THEME.LIGHT, !isDark);
    localStorage.setItem("theme", isDark ? THEME.DARK : THEME.LIGHT);
  }, [isDark]);

  /* Remove loader once app is painted */
  useEffect(() => {
    requestAnimationFrame(() => setIsLoading(false));
  }, []);

  const toggleTheme = () => setIsDark((prev) => !prev);

  if (isLoading) {
    return <Loader theme={isDark ? "dark" : "light"} />;
  }

  return (
    <div className="app">
      <Header
        toggleTheme={toggleTheme}
        currentTheme={isDark ? THEME.DARK : THEME.LIGHT}
      />

      <main className="main-content">
        <About isDarkMode={isDark} />
        <Skills isDarkMode={isDark} />
        <Projects isDarkMode={isDark} />
        <Contact isDarkMode={isDark} />
      </main>
    </div>
  );
};

export default App;
